var React = require('react');

function GreenEnergy (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.63151 13.1375C0.122832 20.645 0.122832 32.855 7.63151 40.3625C11.3996 44.13 16.3229 46 21.2461 46C26.1694 46 31.0927 44.13 34.8608 40.3625C44.4323 30.7925 46 2 46 2C46 2 17.203 3.5675 7.63151 13.1375ZM30.9827 36.485C28.3697 39.07 24.9317 40.5 21.2461 40.5C18.7983 40.5 16.4879 39.8125 14.4251 38.63C16.9555 30.71 21.6312 23.7525 27.8472 18.5C20.6135 22.24 14.5351 28.015 10.3269 35C6.25629 29.61 6.61384 21.9375 11.5371 17.015C16.3229 12.23 29.6074 9.2875 39.9491 8.05C38.7114 18.39 35.7684 31.6725 30.9827 36.485Z","fill":"black"}));
}

GreenEnergy.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = GreenEnergy;

GreenEnergy.default = GreenEnergy;
